import { __awaiter, __generator } from "tslib";
import { logFeature } from '@office-start/telemetry-service';
import { getCapabilitiesAndContext } from './getCapabilitiesAndContext';
import { getLaunchFunctions } from './getLaunchFileFunctions';
export var launchNativeFile = function (launchOptions) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, launchFile, launchInDesktopApps, capabilities, result;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, getLaunchFunctions()];
            case 1:
                _a = _b.sent(), launchFile = _a.launchFile, launchInDesktopApps = _a.launchInDesktopApps;
                return [4 /*yield*/, getCapabilitiesAndContext()];
            case 2:
                capabilities = (_b.sent()).capabilities;
                result = { success: false };
                if (!(launchOptions.webUrl && capabilities.lorByDefaultEnabled)) return [3 /*break*/, 4];
                return [4 /*yield*/, launchInDesktopApps(launchOptions)];
            case 3:
                result = _b.sent();
                _b.label = 4;
            case 4:
                // This event is used for office licensing to run
                // acquisition scorecards and filter on this specific event
                logFeature({
                    featureName: "LinksOpenRight" /* KnownFeatureNames.LinksOpenRight */,
                    eventName: 'LinksOpenRightLaunchNativeFile',
                });
                if (result.success) {
                    return [2 /*return*/, { success: result.success }];
                }
                return [2 /*return*/, launchFile(launchOptions)];
        }
    });
}); };
//# sourceMappingURL=launchNativeFile.js.map